import api from 'services/api';

/**
 * DELETE `/scheduling_windows/:zone_name/:window_name`. Resolves on success;
 * throws on HTTP error (404 for an unknown zone or window, and the DB's own
 * restrict/cascade complaints), which the caller surfaces. The 200 body is a
 * `{ message }` acknowledgement with nothing worth validating.
 *
 * Both path segments are escaped — a name may contain a `/`.
 */
export const deleteSchedulingWindow = async (zoneName: string, windowName: string): Promise<void> => {
  await api.delete(`/scheduling_windows/${encodeURIComponent(zoneName)}/${encodeURIComponent(windowName)}`);
};
